module.exports = __webpack_public_path__ + "icons/original/small/small-f1.cf4eb2f72546034b67c7e387426aab1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-f1.png
// module id = voAe
// module chunks = app